var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HXContentCard',{attrs:{"title":"Labs🧪"}},[_c('div',{staticClass:"py-5"},[_c('speech-input',{model:{value:(_vm.speechText),callback:function ($$v) {_vm.speechText=$$v},expression:"speechText"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }